import {
  Typography,
  Box,
  Table,
  TableHead,
  TableContainer,
  TableBody,
  TableRow,
  TablePagination,
  LinearProgress,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useState } from "react";
import UserAvatar from "../../common/UserAvatar";
import { StyledPaper } from "../../customComponents/styled/styledPaper";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../customComponents/styled/styledTable";
import { useGetClassroomStudentsPaginatedQuery } from "./classApiSlice";

function ClassStudents({ item }) {
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [search, setSearch] = useState("");

  const { data, isLoading } = useGetClassroomStudentsPaginatedQuery(
    { classroom_id: item?.id, page: page + 1, per_page: perPage, q: search },
    { skip: !item?.id }
  );
  const students = data?.students ?? [];
  const totalCount = data?.pagination?.total_items ?? 0;

  return (
    <StyledPaper>
      <Box className="paperHeader">
        <Typography variant="paperHeading">Students</Typography>
      </Box>
      <Box sx={{ px: 2, pb: 1 }}>
        <TextField
          size="small"
          fullWidth
          placeholder="Search students..."
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(0); }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      {isLoading && <LinearProgress />}
      <TableContainer sx={{ pb: 1 }}>
        <Table sx={{ width: "100%", boxShadow: "none" }}>
          <TableHead>
            <TableRow>
              <StyledTableCell>photo</StyledTableCell>
              <StyledTableCell>reg no</StyledTableCell>
              <StyledTableCell>name</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {students.map((student) => (
              <StyledTableRow key={student.id}>
                <StyledTableCell component="th" scope="row">
                  <UserAvatar src={student.photo} name={`${student.first_name || ""} ${student.last_name || ""}`.trim()} />
                </StyledTableCell>
                <StyledTableCell component="th" scope="row">
                  {student.reg_number}
                </StyledTableCell>
                <StyledTableCell component="th" scope="row">
                  {student.first_name} {student.last_name}
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={totalCount}
        page={page}
        onPageChange={(_, newPage) => setPage(newPage)}
        rowsPerPage={perPage}
        onRowsPerPageChange={(e) => { setPerPage(parseInt(e.target.value, 10)); setPage(0); }}
        rowsPerPageOptions={[10, 20, 50]}
      />
    </StyledPaper>
  );
}

export default ClassStudents;
